module.exports = __webpack_public_path__ + "img/1_2023_01_18.eb939fc5.png";